var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234 0.999939C202.8 3.89993 169.8 13.0999 143.5 26.1999C131.7 32.0999 115 42.1999 115 43.3999C115 44.8999 164.7 198.1 165.4 198.7C166.2 199.5 164.3 200.9 280.3 116.5L389 37.4999L385.2 35.1999C378.3 30.8999 361.6 22.6999 350.5 18.2999C331.8 10.7999 309 4.89993 287.5 1.99994C276.4 0.499939 245.5 -0.100067 234 0.999939Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M348.5 103.9C312.2 130.3 282.5 152.2 282.6 152.6C282.7 153.1 332.6 189.7 393.6 234C466.3 286.9 504.7 314.2 505.2 313.5C505.6 312.8 506.8 307.2 507.9 300.9C523.6 212.4 492.1 123 424.1 63.4001C419.5 59.3001 415.5 56.0001 415.1 56.0001C414.8 56.0001 384.8 77.6001 348.5 103.9Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8 72.7C56.6 93.4 39.2 117.5 26.5 143.5C17.2 162.3 12.8 174.5 7.99996 193.5C-2.30004 234.5 -2.60004 274.5 7.09996 315.7L9.29996 325H91.7C136.9 325 174 324.7 174 324.2C174.1 322.1 89.4 63 88.6 63C88.1 63 83.2 67.4 77.8 72.7Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.6 272.2C350.4 285 331.3 343.9 312.1 403C292.9 462.1 277.3 510.7 277.6 510.9C277.8 511.2 282.4 510.8 287.8 510.1C327.6 505 366.4 490.3 399.8 467.8C426.9 449.5 455.1 420.2 473.2 391.4C479.4 381.5 491.8 356.9 494.4 349.5L495.8 345.3L429.9 297.4C393.7 271 363.6 249.4 363.1 249.2C362.5 249 358.7 259.4 354.6 272.2Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 357.4C23.1 363 34.3 384.2 39.4 392.3C53.2 414.2 75.3 439 95.5 455.3C135.5 487.6 191.4 509.5 238.4 511.2L245.3 511.5L270.6 433.5C284.6 390.6 296 355.4 296 355.2C296 355.1 233.9 355 158 355H20L20.9 357.4Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.fa5882304cf19e459c040b239d7f1229.svg";
export { ForwardRef as ReactComponent };